export default {
    CvePoc: {
        title: 'Danh sách mã kiểm thử theo CVE',
        SearchEmptyText: 'Nhập cve, mô tả, giao thức để tìm kiếm',
        name: 'Tên mã kiểm thử',
        cve: 'CVE',
        protocol: 'Giao thức',
        type: 'Phân loại',
        description: 'Mô tả',
        created: 'Ngày tạo',
        modified: 'Ngày sửa',
        user: 'Tài khoản',
        reference: "Tài liệu tham khảo"
    },
    CvePocTask:{
        cve: "CVE",
        poc_name: "Tên mã kiểm thử",
        target: "Địa chỉ mục tiêu",
        port: "Cổng thực hiện",
        created: 'Ngày thực hiện',
        poc_found: 'Thực hiện thành công',
        action: 'Thao tác',
        command: 'Lệnh',
    }
};  
